// extracted by mini-css-extract-plugin
export default {"text":"LongTextView_text__9UmcJ","showMore":"LongTextView_showMore__LnbcQ"};